import { z } from 'zod';
import { StreetIdSchema } from './filtersSchema';

export const CityNameSchema = z.object({
  regionType: z.number(),
  cityId: z.number(),
  city: z.string(),
});
export const CountyNameSchema = z.object({
  regionType: z.number(),
  countyId: z.number(),
  county: z.string(),
});
export const DistrictNameSchema = z.object({
  regionType: z.number(),
  districtId: z.number(),
  district: z.string(),
  regionId: z.number().optional(),
  region: z.string().optional(),
  cityid: z.number().optional(),
  city: z.string().optional(),
});
export const RegionNameSchema = z.object({
  regionType: z.number(),
  regionId: z.number(),
  region: z.string(),
  cityid: z.number().optional(),
  city: z.string().optional(),
});
export const StreetNameSchema = z.object({
  regionType: z.number(),
  streetId: StreetIdSchema,
  street: z.string(),
  city: z.string().optional(),
});

export const LocationNameSchema = z.union([
  DistrictNameSchema,
  RegionNameSchema, // Keep region name after district to avoid the schemas to get mixed up
  CountyNameSchema,
  StreetNameSchema,
  CityNameSchema, // Keep the city name last to avoid it being applied mistakently to more specific region types
]);

export const LocationNameArraySchema = z.array(LocationNameSchema);
